import utils from './../../utils.js';

export default utils.generateNamespace({
    state: [
        'CONFIGURATION',
        'WAITING_FOR_RESPONSE',
        'LOADING_MESSAGE',
        'VIEW_NOTIFICATION'
    ],
    actions: [
        'FETCH',
        'SAVE',
        'CONFIRM_REMOVE',
        'REMOVE',
        'TEST',
        'SET_UP_SERVICE',
        'SET_VIEW_NOTIFICATION',
        'HANDLE_ERROR'
    ],
    mutations: [
        'SET_CONFIGURATION',
        'DISABLE_VIEW',
        'ENABLE_VIEW',
        'SET_VIEW_NOTIFICATION'
    ],
    getters: [
        'CONFIGURATION',
        'WAITING_FOR_RESPONSE',
        'LOADING_MESSAGE',
        'VIEW_NOTIFICATION'
    ]
});



// WEBPACK FOOTER //
// ./src/store/modules/smtp/namespace.js